<!-- eslint-disable max-len -->
<template>
  <div id="form-page-detail">
    <div
      :class="{ 'form-page-detail--header-long' : !is_sidebar_minimized }"
      class="form-page-detail--header">
      <b-row>
        <b-col md="8">
          <div class="name-data--header">{{ dataset_data.name }}</div>
          <div class="id-data--header">{{ dataset_data.id }}</div>
        </b-col>
        <b-col md="4">
          <i
            id="configPopover"
            class="fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__l--10 m__t--10"/>
        </b-col>
      </b-row>
      <b-row
        id="form-header-tab"
        class="form-page-detail--header_tab">
        <b-col
          v-for="tab in tabs"
          :key="tab.id"
          :class="{'studio-page-tab-active' : tabSelected === tab.id}"
          class="studio-page-tab"
          @click="selectTab(tab.id)">
          <h4>{{ tab.label }}</h4>
          <div
            v-if="tabSelected === tab.id"
            class="underline-data"/>
        </b-col>
      </b-row>
    </div>

    <div class="form-page-detail--body">
      <j-dataset-general v-if="tabSelected === 'general'"/>
      <j-dataset-column v-if="tabSelected === 'column'"/>
      <j-dataset-data v-if="tabSelected === 'data'"/>
      <j-dataset-query v-if="tabSelected === 'query'"/>
      <j-dataset-indexes v-if="tabSelected === 'indexes'"/>
      <j-dataset-exp-manager v-if="tabSelected === 'exp-manager'"/>
    </div>

    <b-popover
      ref="configPopoverRef"
      :show.sync="configPopoverShow"
      target="configPopover"
      placement="left">
      <!-- <div
        class="add-automation"
        @click="openCodeForm">View Code</div> -->
      <div
        class="add-automation"
        @click="deleteDataset">Delete Dataset</div>
      <div
        class="add-automation"
        @click="truncateDataset">Truncate Data</div>
    </b-popover>

    <b-modal
      ref="appCodeFormDataModal"
      class="mod-form modal-code-form-data"
      centered>
      <div class="label-create-form-data">VIEW CODE</div>
      <span
        class="btn-delete"
        @click="copyCode">
        <i class="fa fa-files-o font-weight-bold cursor-pointer"/> Copy
      </span><br>
      <div class="scroll-script">
        <prism-editor
          v-model="jsonData"
          :highlight="highlighter"
          :line-numbers="true"
          :class="{'dark-mode' : darkMode}"
          class="my-editor m__t--10"
        />
      </div>
      <br>
      <b-row>
        <b-col md="6">
          <div style="opacity: 0;">
            <textarea
              id="view-code"
              :value="viewCode"/>
          </div>
        </b-col>
        <b-col md="6">
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeCodeForm">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-console */
import jDatasetGeneral from '@/views/joanadb/dataset/jDatasetGeneral';
import jDatasetColumn from '@/views/joanadb/dataset/jDatasetColumn';
import jDatasetData from '@/views/joanadb/dataset/jDatasetData';
import jDatasetQuery from '@/views/joanadb/dataset/jDatasetQuery';
import jDatasetIndexes from '@/views/joanadb/dataset/jDatasetIndexes';
import jDatasetExpManager from '@/views/joanadb/dataset/jDatasetExpManager';
import { mapState, mapActions, mapMutations } from 'vuex';
import jwtDecode from 'jwt-decode';

import { highlight, languages } from 'prismjs/components/prism-core';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

export default {
  components: {
    jDatasetGeneral,
    jDatasetColumn,
    jDatasetData,
    jDatasetQuery,
    jDatasetIndexes,
    jDatasetExpManager,
    PrismEditor,
  },
  props: {
    datasetId: {
      type: String,
      default: '',
    },
    findRecord: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jsonData: '',
      viewCode: '',
      darkMode: false,
      configPopoverShow: false,
      tabSelected: 'general',
      tabs: [
        { id: 'general', label: 'GENERAL' },
        { id: 'column', label: 'COLUMN' },
        // {id: 'data', label: 'DATA'},
        { id: 'query', label: 'QUERY' },
        { id: 'indexes', label: 'INDEXES' },
        { id: 'exp-manager', label: 'EXPERIENCE MANAGER' },
      ],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },
  computed: {
    ...mapState('jStoreFormUi', ['changes_value_view']),
    ...mapState('jStoreJoana', ['dataset_data']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),
    ...mapActions('jStoreJoana', ['deleteDatasetByGroup', 'truncateDatasetByGroup']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    highlighter(code) {
      return highlight(code, languages.js); // returns html
    },

    openCodeForm() {
      // this.configPopoverShow = false;
      // const reqData = {
      //   form_data_id: this.datasetId,
      // };
      // this.findFormData(reqData).then((param) => {
      //   const code = param.data;
      //   delete code.id;
      //   delete code.created_by;
      //   delete code.updated_by;
      //   delete code.created_at;
      //   delete code.updated_at;
      //   delete code.company_id;
      //   this.jsonData = JSON.stringify(code, null, 4);
      //   this.viewCode = JSON.stringify(code, null, 4);
      //   this.$refs.appCodeFormDataModal.show();
      // });
    },

    copyCode() {
      const codeToCopy = document.querySelector('#view-code');
      codeToCopy.setAttribute('type', 'text');
      codeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        // eslint-disable-next-line
        alert('Code was copied ' + msg);
      } catch (err) {
        // eslint-disable-next-line
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();
    },

    closeCodeForm() {
      this.jsonData = '';
      this.$refs.appCodeFormDataModal.hide();
    },

    selectTab(data) {
      if (this.changes_value_view) {
        const text = 'Are you sure want to move without save your changes ?';
        this.$swal({
          title: 'Warning',
          text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#D2232A',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            this.tabSelected = data;
            this.setChangesValueView(false);
          }
        });
      } else {
        this.tabSelected = data;
      }
    },

    deleteDataset() {
      this.configPopoverShow = false;
      if (!this.findRecord) {
        this.$swal({
          title: 'Delete Dataset',
          text: 'Are you sure want to delete this data?',
          showCancelButton: true,
          confirmButtonText: 'Delete',
        }).then((result) => {
          if (result.value) {
            const param = {
              id: this.datasetId,
            };
            this.deleteDatasetByGroup(param).then((res) => {
              if (res.error) {
                this.toggleProblem(res.message);
              } else {
                this.$emit('reload');
              }
            });
          }
        });
      } else {
        this.$store.dispatch('jStoreNotificationScreen/toggleInfo', 'Record Already Exist, Can’t Delete Dataset');
      }
    },

    truncateDataset() {
      this.configPopoverShow = false;
      this.$swal({
        title: 'Truncate Dataset Data',
        text: 'Are you sure want to truncate this dataset?',
        showCancelButton: true,
        confirmButtonText: 'Truncate',
      }).then((result) => {
        if (result.value) {
          const param = {
            dataset_id: this.datasetId,
          };
          this.truncateDatasetByGroup(param).then((res) => {
            if (res.error) {
              this.toggleProblem(res.message);
            } else {
              this.$emit('reload');
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
  #form-page-detail {
    .form-page-detail--header-long {
      width: calc(100% - 375px) !important;
    }

    .form-page-detail--header {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      padding: 21px 15px 1px 15px;
      height: 127px;
      color: #525252;
      position: fixed;
      width: calc(100% - 565px);
      z-index: 10;
      background-color: #ffffff;
      border-bottom: 1px solid #f2f2f2;
      top: 52px;
    }
    .form-page-detail--header_tab {
      text-align: center;
      margin-top: 28px;
    }
    .form-page-detail--body {
      padding: 126px 0px 15px 0px !important;
    }
    .name-data--header {
      color: #525252;
      font-family: 'Poppins-Medium';
      font-size: 18px;
    }
    .id-data--header {
      color: #525252;
      font-family: 'Poppins-Regular';
      font-size: 12px;
    }
  }

  .btn-view-code {
    float: right;
    width: 100px;
    height: 24px;
    padding: 5px;
    margin-right: 5px;
    border-radius: 4px;
    background-color: #f2f2f2;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4a4a4a;
    cursor: pointer;
  }

  .btn-delete {
    float: right;
    width: 72px;
    height: 24px;
    padding: 5px;
    border-radius: 4px;
    background-color: #f2f2f2;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4a4a4a;
    cursor: pointer;
  }

  #form-header-tab {
    .col {
      flex-grow: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/jDatasetPageDetail.vue